import { AxiosError } from 'axios';
import { enqueueSnackbar } from 'notistack';
import { Path } from 'react-hook-form';

type PropsType<T> = {
  error: AxiosError;
  callbackFn: (props: { key: Path<T>; value: string }) => void;
};

function processNestedErrors<T>(
  data: unknown,
  callbackFn: (props: { key: Path<T>; value: string }) => void,
  parentKey = '',
) {
  if (Array.isArray(data)) {
    data.forEach((item, index) => {
      if (item && typeof item === 'object') {
        const currentKey = parentKey ? `${parentKey}.${index}` : `${index}`;
        processNestedErrors(item, callbackFn, currentKey);
      }
    });
  } else if (data && typeof data === 'object') {
    Object.entries(data).forEach(([key, value]) => {
      const currentKey = parentKey ? `${parentKey}.${key}` : key;

      if (Array.isArray(value)) {
        if (value.length > 0 && typeof value[0] === 'string') {
          callbackFn({
            key: currentKey as Path<T>,
            value: value.join(' '),
          });
        } else {
          processNestedErrors(value, callbackFn, currentKey);
        }
      } else if (value && typeof value === 'object') {
        processNestedErrors(value, callbackFn, currentKey);
      } else if (typeof value === 'string') {
        callbackFn({
          key: currentKey as Path<T>,
          value: value,
        });
      }
    });
  }
}

export function mapErrors<T>(props: PropsType<T>) {
  const data = props.error.response?.data as Record<
    string,
    string | Array<string> | object
  >;

  if (data) {
    if (data['non_field_errors']) {
      let message = '';
      const nonFieldErrors = data['non_field_errors'];
      if (Array.isArray(nonFieldErrors)) {
        message = nonFieldErrors.join(' ');
      } else if (typeof nonFieldErrors === 'string') {
        message = nonFieldErrors;
      }
      enqueueSnackbar(message, { variant: 'error' });
    } else {
      processNestedErrors(data, props.callbackFn);
    }
  }
}
